import { lazy } from 'react';

export { default as UserLogin } from './user_login/UserLogin';
export { default as StudentLogin } from './student_login/StudentLogin';
export { default as ChangePassword } from './change_password/ChangePassword';

export const Profile = lazy(() => import('./profile/Profile'));